module.exports = function () {
  this.seq().obj(this.key('n').int(), this.key('e').int());
};